import styled from "styled-components";

const Name = styled.h1`
  font-weight: 800;
  font-size: 2.4rem;
  margin-bottom: 0;
  text-align: center;
`;

export default Name;
